import { useDispatch, useSelector } from 'react-redux';
import { Inbox } from '@rossum/api-client/inboxes';
import { Queue } from '@rossum/api-client/queues';
import { clearValidationMessagesAction } from '../../../../redux/modules/validationMessages/action';
import { State } from '../../../../types/state';
import NoInboxPlaceholder from './NoInboxPlaceholder';
import UpdateInbox from './UpdateInbox';

type QueueEmailsProps = {
  selectedQueue: Queue;
  inbox: Inbox | undefined;
};

const QueueEmailsContainer = ({ selectedQueue, inbox }: QueueEmailsProps) => {
  const dispatch = useDispatch();
  const validationMessages = useSelector(
    (state: State) => state.validationMessages['inbox'] ?? {}
  );

  const clearValidationMessages = (formId: string, inputId: string) =>
    dispatch(clearValidationMessagesAction(formId, inputId));

  return inbox ? (
    <UpdateInbox
      inbox={inbox}
      selectedQueue={selectedQueue}
      clearValidationMessages={clearValidationMessages}
      validationMessages={validationMessages}
    />
  ) : (
    <div data-page-title="queue-emails">
      <NoInboxPlaceholder
        clearValidationMessages={clearValidationMessages}
        validationMessages={validationMessages}
        selectedQueue={selectedQueue}
      />
    </div>
  );
};

export default QueueEmailsContainer;
